import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ auth, role, allowedRoles, children }) => {
  if (!auth) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
